export const ADMIN_ID = 1;
export const DOCTOR_ID = 2;
export const NURSE_ID = 3;
export const DIETITIAN_ID = 4;
export const PHARMACIST_ID = 5;
export const PATIENT_ID = 6;
export const ASSISTANT_ID = 7;
export const ADMIN = 'admin';
export const DOCTOR = 'doctor';
export const NURSE = 'nurse';
export const DIETITIAN = 'dietitian';
export const PHARMACIST = 'pharmacist';
export const PATIENT = 'patient';
export const ASSISTANT = 'assistant';



// WEBPACK FOOTER //
// ./src/constants/RoleConstants.js